import helpers from '@/helpers/helper'

export default {
  install: (app) => {
    app.helpers = helpers
    app.config.globalProperties.$helper = helpers
  }
}